export const DEFAULT_REPLY_TO_EMAIL: string = 'carla.brosche@ordtilhandling.no';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ALLOWED_REPLY_TO_DOMAIN = '@ordtilhandling.no';

export const normalizeReplyToEmail = (value: string) =>
  value.trim().toLowerCase();

export const getInitialReplyToEmail = (replyToEmail?: string) => {
  const normalized = normalizeReplyToEmail(replyToEmail ?? '');
  return normalized || DEFAULT_REPLY_TO_EMAIL;
};

export const getReplyToEmailError = (value: string): string | null => {
  const normalized = normalizeReplyToEmail(value);

  if (!normalized || !EMAIL_PATTERN.test(normalized)) {
    return 'Enter a valid email address.';
  }

  if (!normalized.endsWith(ALLOWED_REPLY_TO_DOMAIN)) {
    return 'Reply-To must use the @ordtilhandling.no domain.';
  }

  return null;
};
